/**
 * Bloco `impact` — o aviso é DADO da operação, não copy da UI (C8 da constitution).
 * Fonte: spec/03-OPERATIONS-CATALOG.md §1.
 */

export const IMPACT_SEVERITIES = ['read-only', 'reversible', 'destructive', 'irreversible'] as const;
export type ImpactSeverity = (typeof IMPACT_SEVERITIES)[number];

export const IMPACT_REVERSIBILITIES = [
  'nenhum efeito',
  'rollback na transação',
  'só via backup',
  'irreversível',
] as const;
export type ImpactReversibility = (typeof IMPACT_REVERSIBILITIES)[number];

export const TYPED_TOKEN_KINDS = ['org-name', 'environment', 'user-email'] as const;
export type TypedTokenKind = (typeof TYPED_TOKEN_KINDS)[number];

export type WriteAction = 'select' | 'insert' | 'update' | 'delete' | 'copy';

export interface ImpactWriteTarget {
  schema: string;
  /** `'*'` significa "toda tabela do schema resolvida pelo inventário dinâmico". */
  table: string;
  keyColumn: string;
  action: WriteAction;
}

export interface OperationImpact {
  severity: ImpactSeverity;
  reversibility: ImpactReversibility;
  writes: readonly ImpactWriteTarget[];
  /** Consequências de negócio em pt-BR, versionadas no registry. */
  consequences: readonly string[];
  requires: {
    backupWithinHours?: number;
    typedToken?: TypedTokenKind;
  };
}

/** Schemas do banco alvo onde o Postgres NÃO desfaz nada sozinho (sem FK para organizations). */
export const SCHEMAS_WITHOUT_FK = [
  'datahouse',
  'providers_raw',
  'gold',
  'bronze',
  'silver',
] as const;

export function isSchemaWithoutFk(schema: string): boolean {
  return (SCHEMAS_WITHOUT_FK as readonly string[]).includes(schema);
}

export function requiresDoubleConfirmation(severity: ImpactSeverity): boolean {
  return severity === 'destructive' || severity === 'irreversible';
}

export const SEVERITY_LABELS: Record<ImpactSeverity, string> = {
  'read-only': 'Somente leitura',
  reversible: 'Reversível',
  destructive: 'Destrutiva',
  irreversible: 'Irreversível',
};

export const TYPED_TOKEN_HINTS: Record<TypedTokenKind, string> = {
  'org-name': 'digite o nome exato da organização',
  environment: 'digite o nome do ambiente (local, staging ou production)',
  'user-email': 'digite o e-mail exato do usuário',
};
